/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import moment from 'moment-timezone';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import utils from '../../../utils/utils';
import SLOT_STATUSES from '../../../constants/slotStatuses';
import guaranteedIcon from '../../../assets/images/guaranteed-icon.svg';
import orientationIcon from '../../../assets/images/black-compass.svg';
import { ReactComponent as OnCall } from '../../../assets/images/badge-on-call.svg';
import { ReactComponent as MarkedAsCalledBack } from '../../../assets/images/marked-as-callback-badge-icon.svg';
import { ReactComponent as CallbackShift } from '../../../assets/images/callback-shift-badge-icon.svg';

export const shiftTypeTemplate = (item) => (
	<div className="d-flex align-items-center shift-type">
		<div className="flex-one shift_type_block line-clamp">{item.shift_type}</div>
		{item.is_guaranteed && (
			<OverlayTrigger
				trigger={['hover', 'focus']}
				key="facility-tooltip"
				placement="top"
				show
				overlay={
					<Tooltip className="facility-menu-item-tooltip" placement="bottom" show>
						<span>Guaranteed Shift</span>
					</Tooltip>
				}
			>
				<img className="guaranteed-badge" src={guaranteedIcon} alt="Guaranteed" />
			</OverlayTrigger>
		)}
		{item.is_orientation && (
			<OverlayTrigger
				trigger={['hover', 'focus']}
				key="facility-tooltip"
				placement="top"
				overlay={
					<Tooltip className="facility-menu-item-tooltip" placement="bottom" show>
						<span>Orientation Shift</span>
					</Tooltip>
				}
			>
				<img className="guaranteed-badge" src={orientationIcon} alt="Orientation shift" />
			</OverlayTrigger>
		)}
		{item.is_on_call_shift && (
			<>
				{!item.marked_as_callback && !item.on_call_slot_id && (
					<OverlayTrigger
						trigger={['hover', 'focus']}
						placement="top"
						overlay={
							<Tooltip className="facility-menu-item-tooltip" placement="bottom">
								<span>On Call shift</span>
							</Tooltip>
						}
					>
						<OnCall width={18} height={18} className="agency-schedule-on-call-badge" />
					</OverlayTrigger>
				)}
				{item.marked_as_callback && (
					<OverlayTrigger
						trigger={['hover', 'focus']}
						placement="top"
						overlay={
							<Tooltip className="facility-menu-item-tooltip" placement="bottom">
								<span>Marked as Called Back</span>
							</Tooltip>
						}
					>
						<MarkedAsCalledBack width={20} height={20} className="agency-schedule-on-call-badge" />
					</OverlayTrigger>
				)}
				{item.on_call_slot_id && (
					<OverlayTrigger
						trigger={['hover', 'focus']}
						placement="top"
						overlay={
							<Tooltip className="facility-menu-item-tooltip" placement="bottom">
								<span>Callback shift</span>
							</Tooltip>
						}
					>
						<CallbackShift width={20} height={20} className="agency-schedule-callback-badge" />
					</OverlayTrigger>
				)}
			</>
		)}
	</div>
);

export const estimatedPayTemplate = (item) => <div>${item.estimated_pay} (estimate)</div>;

export const rateTemplate = (item) => <span>{utils.formatMoney(item.rate)}/hr</span>;

export const startDateTemplate = (item, tab) => {
	const isPast = tab && tab === 'past';
	const isFacilityCancelled =
		item.slot_status === SLOT_STATUSES.FACILITY_CANCELLED || item.shift_replacement_reason === 'SHIFTMED_OVERRIDE';
	const isAgencyCancelled =
		item.shift_replacement_reason &&
		item.shift_replacement_reason !== 'SHIFTMED_OVERRIDE' &&
		item.shift_replacement_reason !== 'DNR';
	const userTimeZone = moment.tz.guess();
	return (
		<OverlayTrigger
			trigger={isFacilityCancelled || isAgencyCancelled ? ['hover', 'focus'] : []}
			key="date-tooltip"
			placement="bottom"
			overlay={
				<Tooltip className="date-menu-item-tooltip facility-info" placement="bottom" show>
					{isFacilityCancelled && item.cancel_event_date && (
						<div>
							Facility cancelled this shift on{' '}
							{moment(item.cancel_event_date).tz(userTimeZone).format('MMMM D, YYYY [(@] h:mm A z[)]')}
						</div>
					)}
					{isAgencyCancelled && item.cancel_event_date && (
						<div>
							Agency cancelled this shift on{' '}
							{moment(item.cancel_event_date).tz(userTimeZone).format('MMMM D, YYYY [(@] h:mm A z[)]')}
						</div>
					)}
				</Tooltip>
			}
		>
			<div className="start-date">
				<span>{moment.tz(item.start_time, item.facility_timezone).format('dddd, MMM D, YYYY')}</span>
				{!isPast && (
					<>
						{isFacilityCancelled && <div className="cancelled-label">Facility Cancelled</div>}
						{isAgencyCancelled && <div className="cancelled-label">Agency Cancelled</div>}
						{item.shift_replacement_reason === 'DNR' && <div className="cancelled-label">Do Not Return</div>}
					</>
				)}
			</div>
		</OverlayTrigger>
	);
};

export const timePeriodTemplate = (item) => (
	<span className="time-period">
		{item.start_hour_tz} - {item.end_hour_tz} {moment.tz(item.start_time, item.facility_timezone).format('z')}
		<br />
		{item.break_duration !== null && !item.is_on_call && (
			<span className="break-duration">({item.break_duration} min break)</span>
		)}
	</span>
);

export const workedTimeRangeTemplate = (item) => (
	<span>
		{item.checkin_time_tz
			? item.checkin_time_tz
			: `____ ${moment.tz(item.start_time, item.facility_timezone).format('A')}`}{' '}
		-{' '}
		{item.checkout_time_tz
			? item.checkout_time_tz
			: `____ ${moment.tz(item.end_time, item.facility_timezone).format('A')}`}
	</span>
);

export const facilityTemplate = (item) => (
	<OverlayTrigger
		trigger={['hover', 'focus']}
		key="facility-tooltip"
		placement="bottom"
		overlay={
			<Tooltip className="facility-menu-item-tooltip facility-info" placement="bottom" show>
				<div>
					<b>{item.facility_name}</b>
				</div>
				<br />
				<div>{item.facility_address}</div>
				<div>
					{item.facility_city}, {item.facility_state_code} {item.facility_zip_code}
				</div>
			</Tooltip>
		}
	>
		<div className="facility-name line-clamp">{item.facility_name}</div>
	</OverlayTrigger>
);

export const contractPeriodTemplate = (item) => (
	<div>
		<span>{moment.tz(item.contract_start_time, item.facility_timezone).format('MMM D')}</span> -{' '}
		<span>{moment.tz(item.contract_end_time, item.facility_timezone).format('MMM D, YYYY')}</span>
	</div>
);

export const idBodyTemplate = (item, onSelectBundle) => {
	if (item.contract_id) {
		return (
			<div className="bundle-link" onClick={() => onSelectBundle(item.contract_id)}>
				{item.contract_id}
			</div>
		);
	}
	return <span>{item.id}</span>;
};

export const bundleFlagTemplate = (item) => {
	return <span>{item.contract_id ? 'Yes' : 'No'}</span>;
};

export const DEFAULT_FILTER_OPTIONS = {
	facilities: [],
	states: [],
	shiftTypes: [],
	startTimes: []
};

export const buildFilterOptions = (shifts, filters) => {
	const addedFacilities = {};
	const addedStates = {};
	const addedTypes = {};
	const addedTimes = {};
	const _facilities = [];
	const _states = [];
	const _shiftTypes = [];
	const _startTimes = [];
	for (let i = 0; i < shifts.length; i++) {
		const {
			facility_id: facilityId,
			facility_name: facilityName,
			facility_state_code: facilityStateCode,
			shift_type: shiftType,
			start_hour_tz: startHour
		} = shifts[i];
		if (!addedFacilities[facilityId]) {
			addedFacilities[facilityId] = 1;
			const _selected = !filters.facilities?.length || filters.facilities?.includes(facilityId);
			_facilities.push({ value: facilityId, label: facilityName, checked: _selected });
		}
		if (!addedTypes[shiftType]) {
			addedTypes[shiftType] = 1;
			const _selected = !filters.shiftTypes?.length || filters.shiftTypes?.includes(shiftType);
			_shiftTypes.push({ value: shiftType, label: shiftType, checked: _selected });
		}
		if (filters.startTimes && !addedTimes[startHour]) {
			addedTimes[startHour] = 1;
			const _selected = !filters.startTimes?.length || filters.startTimes?.includes(startHour);
			_startTimes.push({ value: startHour, label: startHour, checked: _selected });
		}
		if (filters.states && !addedStates[facilityStateCode]) {
			addedStates[facilityStateCode] = 1;
			const _selected = !filters.states?.length || filters.states?.includes(facilityStateCode);
			_states.push({ value: facilityStateCode, label: facilityStateCode, checked: _selected });
		}
	}

	const returnData = {
		facilities: utils.sort(_facilities, 'value'),
		shiftTypes: utils.sort(_shiftTypes, 'value'),
		startTimes: utils.sortTimeStrings(_startTimes, 'value')
	};
	if (filters.states) {
		returnData.states = utils.sort(_states, 'value');
	}

	return returnData;
};

export const idFieldTemplate = (item) => item.contract_id || item.id;
